<template>
    <div>
        <viewer v-if="isKonfirmasi" :isKonfirmasi="isKonfirmasi" :value="form" @koreksi="isKonfirmasi = false" @saved="save"></viewer>
        <b-card v-show="!isKonfirmasi" class="m-0" no-body>
            <b-card-header class="d-flex justify-content-between align-items-center">
                <h5 class="modal-title">{{ isEdit ? 'Edit Penjualan Tembakau' : 'Penjualan Tembakau' }}</h5>
            </b-card-header>
            <b-card-body>
                <div class="form-group">
                    <label>Pembeli</label>
                    <input v-validate="'required'" v-model="form.pembeli" type="text" name="pembeli" class="form-control">
                    <span class="text-danger">{{ errors.first('pembeli') }}</span>
                </div>

                <div class="form-group">
                    <label class="form-control-label">Tanggal</label>
                    <input readonly v-model="tanggal" type="text" name="tanggal" class="form-control bg-white">
                </div>

                <div class="form-group">
                    <label class="form-control-label">Gudang</label>
                    <div class="input-group mb-0 d-flex">
                        <multiselect class="w-auto flex-grow-1" v-validate="'required'" name="gudang" v-model="form.gudang" :options="gudangOptions" :placeholder="'Pilih gudang'" :searchable="true"
                            label="name" track-by="id" :show-labels="false"></multiselect>
                        <div class="input-group-append">
                            <button class="btn btn-primary" type="button" @click="selectGudang = true"><i class="fas fa-search"></i> Pilih Gudang</button>
                        </div>
                    </div>
                    <span class="text-danger">{{ errors.first('gudang') }}</span>
                </div>

                <div class="form-group mb-0">
                    <label class="form-control-label">Tembakau</label>
                </div>
                <div class="row mb-3">
                    <div class="col-md">
                        <div class="table-responsive mb-0">
                            <table class="table">
                                <tr>
                                    <th>Kode</th>
                                    <th>Grade</th>
                                    <th>Berat</th>
                                    <th>Harga/kg</th>
                                    <th class="text-nowrap">Total Harga</th>
                                    <th class="text-center">Aksi</th>
                                </tr>
                                <tr v-for="(item, index) in barangs">
                                    <td class="text-nowrap pl-0 fit-column">
                                        <div class="input-group mb-0 d-flex" style="width: 20rem;">
                                            <multiselect style="width:10rem; max-width: 10rem;" :class="'w-auto flex-grow-1'" v-model="barangs[index]" :options="[barangs[index]]" :placeholder="'Pilih barang'" :searchable="true"
                                                label="code" track-by="id" :allowEmpty="false" :show-labels="false"></multiselect>
                                            <div class="input-group-append">
                                                <button class="btn btn-primary mr-1" type="button" @click="findBarang(index)"><i class="fas fa-search"></i> Pilih</button>
                                                <button class="btn btn-primary" type="button" @click="findScan(index)"><i class="fas fa-qrcode"></i> Scan</button>
                                            </div>
                                        </div>
                                        <input v-show="false" v-validate="'required'" v-model="item.id" type="text" :name="'barang-'+index" class="form-control">
                                        <span class="text-danger">{{ errors.first('barang-'+index) }}</span>
                                    </td>
                                    <td class="text-nowrap">
                                        {{ item.latest_grade ? item.latest_grade.name : '-' }}
                                    </td>
                                    <td class="text-nowrap pl-0 fit-column">
                                        <div v-if="item.id" class="input-group mb-0 d-flex" style="width: 10rem;">
                                            <input style="width:7rem; max-width: 7rem;" v-validate="'required'" v-model="barangs[index].latest_bobot" type="number" :name="'bobot'+index" class="form-control">
                                            <div class="input-group-append">
                                                <span class="input-group-text">KG</span>
                                            </div>
                                        </div>
                                        <div v-else>-</div>
                                        <span class="text-danger">{{ errors.first('bobot'+index) }}</span>
                                    </td>
                                    <td class="text-nowrap pl-0 fit-column">
                                        <div v-if="item.id" class="input-group mb-0 d-flex" style="width: 8rem;">
                                            <input style="width:8rem; max-width: 8rem;" v-validate="'required'" v-model="barangs[index].harga" type="number" :name="'harga'+index" class="form-control">
                                        </div>
                                        <div v-else>-</div>
                                        <span class="text-danger">{{ errors.first('harga'+index) }}</span>
                                    </td>
                                    <td class="text-center">
                                        <span>{{ formatNumber((item.latest_bobot || 0) * (item.harga || 0)) }}</span>
                                    </td>
                                    <td class="text-center">
                                        <button v-if="barangs.length > 1" type="button" title="Delete" @click="deleteBarang(index)" class="btn btn-link text-danger px-1"><i class="fas fa-times-circle"></i></button>
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <button class="btn btn-sm btn-primary" type="button" @click="addBarang"><i class="fas fa-plus"></i> Barang</button>
                    </div>
                </div>

                <div class="table-responsive pengurang">
                    <table class="table table-borderless">
                        <tr>
                            <th class="fit-column">
                                <label class="form-check-label" for="defaultCheck1">
                                    Berat Total
                                </label>
                            </th>
                            <td class="fit-column">:</td>
                            <th class="text-primary">
                                {{ formatNumber(beratTotal) }}
                            </th>
                        </tr>
                        <tr>
                            <th class="fit-column text-danger">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" v-model="form.pengurang_status">
                                    <label class="form-check-label" for="defaultCheck1">
                                        Pengurang (-)
                                    </label>
                                </div>
                            </th>
                            <td class="fit-column">:</td>
                            <th class="text-danger">
                                <div class="input-group" v-show="form.pengurang_status">
                                    <input v-validate="'min_value:0|max_value:100'" min="0" max="100" v-model="form.pengurang" type="number" name="pengurang" class="form-control">
                                    <div class="input-group-append">
                                        <span class="input-group-text" id="basic-addon1">%</span>
                                    </div>
                                </div>
                                <span class="text-danger">{{ errors.first('pengurang') }}</span>
                            </th>
                        </tr>
                        <tr>
                            <th class="fit-column text-danger">
                                <div class="form-check">
                                    <label class="form-check-label" for="defaultCheck1">
                                        Berat akhir (-)
                                    </label>
                                </div>
                            </th>
                            <td class="fit-column">:</td>
                            <th class="text-danger">
                                {{ formatNumber(beratAkhir) }}
                            </th>
                        </tr>
                        <tr>
                            <th class="fit-column text-info">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" v-model="form.pajak_status">
                                    <label class="form-check-label" for="defaultCheck1">
                                        Pajak (-)
                                    </label>
                                </div>
                            </th>
                            <td class="fit-column">:</td>
                            <th class="text-info">
                                <div class="input-group" v-show="form.pajak_status">
                                    <input v-validate="'min_value:0|max_value:100'" min="0" max="100" v-model="form.pajak" type="number" name="pajak" class="form-control">
                                    <div class="input-group-append">
                                        <span class="input-group-text" id="basic-addon1">%</span>
                                    </div>
                                </div>
                                <span class="text-danger">{{ errors.first('pajak') }}</span>
                            </th>
                        </tr>
                        <tr>
                            <th class="fit-column text-info">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" v-model="form.admin_status">
                                    <label class="form-check-label" for="defaultCheck1">
                                        Admin (-)
                                    </label>
                                </div>
                            </th>
                            <td class="fit-column">:</td>
                            <th class="text-info">
                                <input v-show="form.admin_status" v-validate="'min_value:0'" min="0" v-model="form.admin" type="number" name="admin" class="form-control">
                                <span class="text-danger">{{ errors.first('admin') }}</span>
                            </th>
                        </tr>
                        <tr>
                            <th class="fit-column text-info">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" v-model="form.potongan_status">
                                    <label class="form-check-label" for="defaultCheck1">
                                        Potongan (-)
                                    </label>
                                </div>
                            </th>
                            <td class="fit-column">:</td>
                            <th class="text-info">
                                <input v-show="form.potongan_status" v-model="form.potongan_notes" type="text" placeholder="Keterangan" name="potongan_notes" class="form-control">
                            </th>
                        </tr>
                        <tr v-show="(form && form.potongan_notes) || (form && form.potongan_status)">
                            <th></th>
                            <td></td>
                            <th class="text-info">
                                <input v-show="form.potongan_status" v-validate="'min_value:0'" min="0" v-model="form.potongan" type="number" name="bonus" class="form-control">
                                <span class="text-danger">{{ errors.first('bonus') }}</span>
                            </th>
                        </tr>
                        <tr>
                            <th class="fit-column text-warning">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" v-model="form.bonus_status">
                                    <label class="form-check-label" for="defaultCheck1">
                                        Bonus (+)
                                    </label>
                                </div>
                            </th>
                            <td class="fit-column">:</td>
                            <th class="text-warning">
                                <input v-show="form.bonus_status" v-model="form.bonus_notes" type="text" placeholder="Keterangan" name="bonus_notes" class="form-control">
                            </th>
                        </tr>
                        <tr v-show="(form && form.bonus_notes) || (form && form.bonus_status)">
                            <th></th>
                            <td></td>
                            <th class="text-warning">
                                <input v-show="form.bonus_status" v-validate="'min_value:0'" min="0" v-model="form.bonus" type="number" name="bonus" class="form-control">
                                <span class="text-danger">{{ errors.first('bonus') }}</span>
                            </th>
                        </tr>
                        <tr>
                            <th class="fit-column">GRAND TOTAL</th>
                            <td class="fit-column">:</td>
                            <th class="text-primary">{{ form ? formatNumber(totalPembayaran) : '-' }}</th>
                        </tr>
                    </table>
                </div>

                <div class="form-group">
                    <label>DP</label>
                    <input v-validate="'required|min_value:0'" min="0" v-model="form.dp" type="number" name="dp" class="form-control">
                    <span class="text-danger">{{ errors.first('dp') }}</span>
                </div>

                <div class="form-group">
                    <label class="form-control-label">Metode Bayar</label>
                    <multiselect v-validate="'required'" class="w-auto flex-grow-1" name="metode_bayar" v-model="form.metode_pembayaran" :options="metodeOptions"
                        label="value" track-by="name" :allowEmpty="false" placeholder="" :show-labels="false"></multiselect>
                    <span class="text-danger">{{ errors.first('metode_bayar') }}</span>
                </div>

                <div class="form-group" v-if="form.total_pelunasan">
                    <label>Total Pelunasan</label>
                    <input readonly min="0" v-model="form.total_pelunasan" type="number" name="total_pelunasan" class="form-control bg-white">
                </div>

                <div class="form-group">
                    <label>Kekurangan</label>
                    <input :value="formatNumber(kekurangan)" type="text" name="kekurangan" class="form-control bg-white text-primary font-weight-bold" disabled>
                </div>

                <div class="form-group">
                    <label>Keterangan</label>
                    <input v-model="form.keterangan" type="text" name="keterangan" class="form-control">
                </div>
            </b-card-body>
            <b-card-footer class="d-flex flex-row-reverse">
                <button :disabled="isLoading" v-if="!isKonfirmasi" @click="$emit('cancel')" type="button" class="btn btn-secondary" data-dismiss="modal">{{ viewMode ? 'OK' : 'Batal' }}</button>
                <button :disabled="isLoading" v-if="!isEdit && !isKonfirmasi && !viewMode" @click="konfirmasi" type="button" class="btn btn-primary mr-2">Jual</button>
                <button :disabled="isLoading" v-if="isEdit" @click="save(false)" type="button" class="btn btn-primary mr-2">Simpan</button>
                <button :disabled="isLoading" v-if="isKonfirmasi" @click="koreksi" type="button" class="btn btn-secondary">Koreksi</button>
                <button :disabled="isLoading" v-if="isKonfirmasi" @click="save(true)" type="button" class="btn btn-primary mr-2">Cetak</button>
            </b-card-footer>
        </b-card>

        <b-modal v-model="selectGudang" size="lg" :hide-header="true" :hide-footer="true">
            <gudang-selector :gudang-id="form.gudang ? form.gudang.id : null" :selected="gudangOptions" @selected="gudangSelected" @cancel="selectGudang = false"></gudang-selector>
        </b-modal>

        <b-modal v-model="selectBarang" size="lg" :hide-header="true" :hide-footer="true">
            <barang-selector one-data all-data :selected="barangs" :latest-gudang-id="form.gudang ? form.gudang.id : null" @selected="barangSelected" @cancel="selectBarang = false"></barang-selector>
        </b-modal>

        <b-modal v-model="scanBarang" size="md" :hide-header="true" :hide-footer="true">
            <scan-qr-code :selected="barangs" @decoded="scanned"></scan-qr-code>
		</b-modal>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import GudangSelector from '../gudangs/Selector';
import Viewer from './Viewer';
import BarangSelector from '../../components/BarangSelector';
import ScanQrCode from '../../components/ScanQrCode';
import DatePicker from 'vue2-datepicker';

export default {
    name: "penjualan-tembakau-form",

    props: {
        isEdit: {
            type: Boolean,
            default: () => {},
        },

        value: {
            type: Object,
            default: null,
        }
    },

    components: {
        Multiselect,
        GudangSelector,
        Viewer,
        BarangSelector,
        ScanQrCode,
        DatePicker,
    },

    data() {
        return {
            form: null,
            barangs: null,
            selectGudang: false,
            selectBarang: false,
            scanBarang: false,
            barangIndex: 0,
            barangOptions: [],
            selectGudang: false,
            gudangOptions: [],
            isKonfirmasi: false,
            metodeOptions: [
                {
                    name: 'tunai',
                    value: 'Tunai',
                },
                {
                    name: 'transfer',
                    value: 'Transfer',
                },
            ],
        }
    },

    created() {
        this.resetForm();
    },

    mounted() {
        this.initForm();
    },

    computed: {
        tanggal() {
            return this.formatDate(new Date());
        },

        beratTotal() {
            let self = this,
                total = 0;
            self.barangs.map(barang => {
                if (barang.latest_bobot) {
                    total += parseInt(barang.latest_bobot);
                }
            });
            return total;
        },

        beratAkhir() {
            let self = this;
            return Math.floor(self.beratTotal - (self.form.pengurang_status ? self.beratTotal * self.form.pengurang / 100 : 0));
        },

        totalHarga() {
            let self = this,
                total = 0;
            self.barangs.map(barang => {
                if (barang.latest_bobot && barang.harga) {
                    total += (parseInt(barang.latest_bobot * barang.harga));
                }
            });
            return total;
        },

        totalPembayaran() {
            let self = this;
            let beratAkhir = self.beratAkhir;
            let hargaKotor = self.totalHarga;
            let hargaSatuan = hargaKotor / self.beratTotal;
            let totalHarga = parseInt(Math.floor(hargaSatuan * beratAkhir));
            let pajak = self.form.pajak_status && self.form.pajak ? parseInt(Math.floor(totalHarga * self.form.pajak / 100)) : 0;
            let admin = self.form.admin_status && self.form.admin ? parseInt(self.form.admin) : 0;
            let potongan = self.form.potongan_status && self.form.potongan ? parseInt(self.form.potongan) : 0;
            let bonus = self.form.bonus_status && self.form.bonus ? parseInt(self.form.bonus) : 0;
            return totalHarga - pajak - admin - potongan + bonus;
        },

        kekurangan() {
            return this.totalPembayaran - parseInt(this.form.dp) - parseInt(this.form.total_pelunasan || 0);
        }
    },

    watch: {
        value() {
            this.initForm();
        }
    },

    methods: {
        initForm() {
            let self = this;
            self.form = Object.assign({}, {
                pengurang: 10,
                pengurang_status: false,
                pajak: 0.5,
                pajak_status: false,
                admin: 10000,
                admin_status: false,
                potongan: null,
                potongan_notes: null,
                potongan_status: false,
                bonus: null,
                bonus_notes: null,
                bonus_status: false,
            });
            self.form.created_at = new Date();
            self.form.gudang = Object.assign({}, self.userGudang);
            if (self.value) {
                self.form = Object.assign({}, self.value);
                self.barangs = [];
                self.form.kemasans.forEach(kemasan => {
                    self.barangs.push(Object.assign({}, {
                        id: kemasan.pembelian_tembakau.id,
                        code: kemasan.pembelian_tembakau.code,
                        latest_bobot: kemasan.bobot,
                        latest_grade: kemasan.grade ? Object.assign({}, kemasan.grade) : null,
                        harga: kemasan.harga,
                    }));
                });
            }
            if (self.form.gudang) {
                self.gudangOptions.push(Object.assign({}, self.form.gudang));
            }
            let metodeIndex = self.metodeOptions.findIndex(option => option.name == self.form.metode_pembayaran);
            self.form.metode_pembayaran = Object.assign({}, self.metodeOptions[metodeIndex]);
        },
        resetForm() {
            this.form = Object.assign({}, {
                form: {
                    id: '',
                    gudang: null,
                    jumlah: '',
                    harga: '',
                    dp: '',
                    metode_pembayaran: null,
                }
            });

            this.barangs = Object.assign([], [
                {
                    bobot: null,
                    grade: null,
                    harga: null,
                },
            ]);
        },

        konfirmasi() {
            let self = this;

            self.$validator.validateAll().then(result => {
                if (result) {
                    self.form.berat_akhir = self.beratAkhir;
                    self.form.total = self.totalPembayaran;
                    self.form.kekurangan = self.kekurangan;
                    self.form.kemasans = Object.assign([], self.barangs);
                    self.isKonfirmasi = true;
                }
            });
        },

        save() {
            let self = this;

            self.isLoading = true;
            let data = {
                pembeli: self.form.pembeli,
                gudang_id: self.form.gudang.id,
                pembelian_tembakau_ids: self.barangs.map(barang => barang.id),
                pembelian_tembakau_bobots: self.barangs.map(barang => barang.latest_bobot),
                pembelian_tembakau_hargas: self.barangs.map(barang => barang.harga),
                pengurang: self.form.pengurang,
                pengurang_status: self.form.pengurang_status,
                berat_akhir: self.beratAkhir,
                pajak: self.form.pajak,
                pajak_status: self.form.pajak_status,
                admin: self.form.admin,
                admin_status: self.form.admin_status,
                potongan: self.form.potongan,
                potongan_status: self.form.potongan_status,
                potongan_notes: self.form.potongan_notes,
                bonus: self.form.bonus,
                bonus_status: self.form.bonus_status,
                bonus_notes: self.form.bonus_notes,
                total: self.totalPembayaran,
                kekurangan: self.kekurangan,
                dp: self.form.dp,
                metode_pembayaran: self.form.metode_pembayaran ? self.form.metode_pembayaran.name : null,
                keterangan: self.form.keterangan,
            }

            self.$Progress.start();
            axios({
                method: self.isEdit ? 'put' : 'post',
                url: self.isEdit ? '/api/penjualan-tembakaus/'+self.form.id : '/api/penjualan-tembakaus',
                data: data
            })
            .then(function (response) {
                Toast.fire({
                    icon: 'success',
                    title: response.data.message
                });
                self.isLoading = false;
                self.$Progress.finish();
                self.$emit('saved');
            })
            .catch(function (error) {
                self.requestFailed(error);
            });
        },

        print(data) {
            let self = this;

            self.isLoading = true;
            self.$Progress.start();
            var newIframe = document.createElement('iframe');
            newIframe.width = '0';
            newIframe.height = '0';
            newIframe.src = '/tebasans/print/'+data.id;
            document.body.appendChild(newIframe);
            newIframe.focus();
            newIframe.onload = function () {
                self.isLoading = false;
                self.$Progress.finish();
                newIframe.contentWindow.print();
                self.$emit('saved', data);
            }
        },

        koreksi() {
            this.isKonfirmasi = false;
        },

        gudangSelected(gudang) {
            let self = this;

            self.gudangOptions.push(gudang);
            self.form.gudang = Object.assign({}, gudang);
            self.selectGudang = false;
        },

        addBarang() {
            this.barangs.push(Object.assign({}, {
                id: null,
                code: null,
                bobot: null,
                grade: null,
            }));
        },

        deleteBarang(index) {
            this.barangs.splice(index, 1);
        },

        findBarang(index) {
            this.barangIndex = index;
            this.selectBarang = true;
        },

        findScan(index) {
            this.barangIndex = index;
            this.scanBarang = true;
        },

        barangSelected(barang) {
            let self = this;

            let index = self.barangOptions.findIndex(b => b.code == barang.code);
            if (index > -1) {
                self.barangs[self.barangIndex] = Object.assign({}, self.barangOptions[index]);
            } else {
                self.barangs[self.barangIndex] = Object.assign({}, barang);
                self.barangOptions.push(barang);
            }
            this.barangs = Object.assign([], self.barangs);
            self.selectBarang = false;
        },

        scanned(value) {
            let self = this;

            let index = self.barangOptions.findIndex(barang => barang.code == value);
            if (index > -1) {
                self.barangs[self.barangIndex] = Object.assign({}, self.barangOptions[index]);
            } else {
                self.getBarang(value);
            }
            self.scanBarang = false;
        },

        getBarang(code) {
            let self = this;

            self.isLoading = true;
            self.$Progress.start();
            axios({
                method: 'get',
                url: '/api/pembelian-tembakaus?is_pilih=1&search='+code+'&all_data=1&latest_gudang_id='+(self.form.gudang_asal ? self.form.gudang_asal.id : ''),
            })
            .then(function (response) {
                Toast.fire({
                    icon: 'success',
                    title: response.data.message
                });
                self.isLoading = false;
                self.$Progress.finish();
                if (response.data.data.length) {
                    let data = Object.assign({}, response.data.data[0]);
                    self.barangOptions.push(data);
                    self.barangs[self.barangIndex] = Object.assign({}, data);
                    self.form.gudang_asal = Object.assign({}, data.latest_gudang);
                } else {
                    Toast.fire({
                        icon: 'warning',
                        title: 'Kode ' + code + ' tidak ditemukan.'
                    });
                }
            })
            .catch(function (error) {
                self.requestFailed(error);
            });
        },
    },
}
</script>
<style>
.multiselect__placeholder {
    margin-bottom: 0;
}

th, td {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
}

.pengurang > table > tr > th {
    padding-left: 0 !important
}
</style>
